import React, { useState, useRef, useEffect } from "react";

function Toolbar({ quickNotes, onSendQuickNote, onSendFile }) {
  const API_UPLOAD_URL =
    process.env.REACT_APP_API_UPLOAD_URL || "http://localhost:3001/api/upload"; // URL para descargar archivos de notas rápidas

  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {

    function handleClickOutside(event) {

      // si el click NO fue dentro del componente
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target)
      ) {
        setIsModalOpen(false);
      }
    }

    function handleKeyDown(event) {

      if (event.key === 'Escape') {
        setIsModalOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);


    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };

  }, []);

  // Función para manejar el clic en una nota
  const handleNoteClick = async (note) => {
    // 1. Si la nota TIENE un archivo adjunto
    if (note.media_url) {
      try {
        // Mostrar algún indicador de carga opcional aquí si el archivo es pesado

        // A. Descargar el archivo como un Blob (datos binarios)
        const response = await fetch(`${API_UPLOAD_URL}${note.media_url}`);
        if (!response.ok) throw new Error("No se pudo descargar el archivo");
        const blob = await response.blob();

        // B. Extraer el nombre original del archivo desde la URL (ej. "media_123.jpg")
        const filename = note.media_url.split("/").pop() || "documento_adjunto";

        // C. Convertir el Blob en un objeto File nativo de JavaScript
        const file = new File([blob], filename, { type: blob.type });

        // D. Determinar el tipo de mensaje para Meta
        let type = "document";
        if (blob.type === "image/webp") type = "sticker";
        else if (blob.type.startsWith("image/")) type = "image";
        else if (blob.type.startsWith("video/")) type = "video";
        else if (blob.type.startsWith("audio/")) type = "audio";

        // E. Enviar usando tu función onSendFile (que es handleSendMessage en el padre)
        if (onSendFile) {
          onSendFile(note.body, file, type);
        }
      } catch (error) {
        console.error("Error al procesar el archivo adjunto:", error);
        alert("Hubo un error al adjuntar el archivo de la nota rápida.");
      }
    }
    // 2. Si la nota es SOLO TEXTO
    else {
      onSendQuickNote(note.body);
    }

    setIsModalOpen(false); // Cierra la modal
  };


  return (
    <div ref={modalRef} style={styles.toolbarContainer}>
      {/* --- NUEVO: Input de archivo oculto --- */}
      {/* <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileSelect}
        accept="image/*,video/*,application/pdf,.doc,.docx,.xls,.xlsx"
      /> */}

      {/* --- NUEVO: Botón para adjuntar archivo --- */}
      {/* <button 
        type="button" 
        style={styles.toolbarButton}
        onClick={() => fileInputRef.current?.click()}
        title="Adjuntar archivo"
      >
        📎
      </button> */}

      {/* NUEVO: Boton para grabar audio */}
      {/* <button 
        type="button" 
        style={styles.toolbarButton}
        onClick={() => alert('Funcionalidad de grabación de audio aún no implementada.')}
        title="Grabar audio"
      >
        🎤
      </button> */}

      {/* Botón para abrir las notas rápidas */}
      <button
        type="button"
        style={styles.toolbarButton}
        onClick={() => setIsModalOpen(!isModalOpen)}
        title="Notas Rápidas"
      >
        ⚡
      </button>

      {/* Ventana Modal / Popover */}
      {isModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalHeader}>
            <h4 style={{ margin: 0, fontSize: "14px", color: "#333" }}>
              Respuestas Guardadas
            </h4>
            <button
              onClick={() => setIsModalOpen(false)}
              style={styles.closeButton}
            >
              ✕
            </button>
          </div>

          <div style={styles.notesList}>
            {quickNotes && quickNotes.length > 0 ? (
              [...quickNotes]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((note) => (
                  <button
                    key={note.id}
                    style={styles.noteItem}
                    onClick={() => handleNoteClick(note)}
                  >
                    <strong
                      style={{
                        display: "block",
                        marginBottom: "4px",
                        color: "#2563eb",
                      }}
                    >
                      {note.name}
                    </strong>
                  </button>
                ))
            ) : (
              <div
                style={{
                  padding: "15px",
                  textAlign: "center",
                  fontSize: "13px",
                  color: "#999",
                }}
              >
                No hay notas rápidas creadas.
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// Estilos separados para mantener el JSX limpio
const styles = {
  toolbarContainer: {
    position: "relative",
    padding: "8px 15px",
    backgroundColor: "#6145a3",
    borderTop: "1px solid #e2e8f0",
    display: "flex",
    gap: "10px",
  },
  toolbarButton: {
    padding: "6px 12px",
    backgroundColor: "#fff",
    border: "1px solid #cbd5e1",
    borderRadius: "20px",
    cursor: "pointer",
    fontSize: "15px", // Un poco más grande para que los emojis se vean bien
    fontWeight: "500",
    color: "#475569",
    transition: "background-color 0.2s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalOverlay: {
    position: "absolute",
    bottom: "100%",
    left: "15px",
    marginBottom: "10px",
    width: "300px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
    border: "1px solid #e2e8f0",
    zIndex: 1000,
    display: "flex",
    flexDirection: "column",
    maxHeight: "350px",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 15px",
    borderBottom: "1px solid #f1f5f9",
    backgroundColor: "#f8fafc",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  closeButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    color: "#94a3b8",
    padding: "0",
  },
  notesList: {
    overflowY: "auto",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  noteItem: {
    textAlign: "left",
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    padding: "5px",
    borderRadius: "3px",
    cursor: "pointer",
    width: "100%",
    transition: "border-color 0.2s, background-color 0.2s",
    textTransform: "uppercase",
  },
};

export default Toolbar;
